import type { DeleteApprovalMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * Maps the tRPC mutation response to match the GraphQL mutation structure.
 */
const mapTrpcResponseToGraphQL = (trpcData: {
  affected_rows: number;
}): DeleteApprovalMutation => ({
  delete_approval: {
    __typename: 'approval_mutation_response',
    affected_rows: trpcData.affected_rows,
  },
});

export const useDeleteApprovalTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.approval.delete.mutationOptions({
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.approval.globalApprovals.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.approval.approvalLevels.queryKey(),
          }),
        ]);
      },
    }),
  });

  return {
    deleteApproval: async (variables: {
      Id: string;
    }): Promise<DeleteApprovalMutation> => {
      const result = await mutation.mutateAsync({ Id: variables.Id });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
